import {
  category_status_class,
  currency_from_number,
  number_from_currency
} from './procurement_compliance_helpers';

function utilisation_class_for_values(planned_number, committed_number) {
  if (committed_number > planned_number) return 'success';
  if (committed_number > planned_number * 0.7) return 'warning';
  return 'danger';
}

export function category_row_payload(context) {
  const category = context.category_form.category.trim();
  if (!category) return null;
  const planned_number = number_from_currency(context.category_form.planned_budget);
  const committed_number = number_from_currency(context.category_form.committed_to_date);
  const utilisation_value = Math.round((committed_number / (planned_number || 1)) * 100);
  const utilisation_class = utilisation_class_for_values(planned_number, committed_number);
  const row_payload = {
    category,
    planned: currency_from_number(planned_number),
    committed: currency_from_number(committed_number),
    utilisation_value: `${utilisation_value}%`,
    utilisation_pct: Math.min(utilisation_value, 100),
    utilisation_class,
    status: { label: context.category_form.status, class: category_status_class(context.category_form.status) },
    highlighted: context.category_modal_mode === 'create'
  };
  return row_payload;
}
